export const methods = (state) => ({
  increaseSortCounter() {
    state.centralHeatings.table.counter += 1;
  },
  resetSortCounter() {
    state.centralHeatings.table.counter = 0;
  },
});
